import { categories } from './utils/constants'

const {
  NODE_ENV,
  REACT_APP_FIREBASE_API_KEY,
  REACT_APP_FIREBASE_AUTH_DOMAIN,
  REACT_APP_FIREBASE_DATABASE_URL,
  REACT_APP_FIREBASE_PROJECT_ID,
  REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  REACT_APP_FIREBASE_SERVER_KEY,
  REACT_APP_GIT_REV,
  REACT_APP_GOOGLE_MAPS_API_KEY,
  STORYBOOK_GOOGLE_MAPS_API_KEY,
  REACT_APP_ENCRYPT_KEY,
  REACT_APP_CATEGORY,
  REACT_APP_API_HOST,
} = process.env

const isDev = NODE_ENV === 'development'

const configDevelopment = {
  admin: {
    name: 'admin',
    countMax: 100,
  },
}
const configProduction = {
  admin: {
    name: 'proadmin',
    countMax: 100,
  },
}

const categoryKey = REACT_APP_CATEGORY || ''

const config = {
  isDev,
  tabBarHeight: 40,
  gitrev: REACT_APP_GIT_REV || '',
  category: categories[categoryKey] || '',
  categoryKey,
  firebase: {
    apiKey: REACT_APP_FIREBASE_API_KEY || '',
    authDomain: REACT_APP_FIREBASE_AUTH_DOMAIN || '',
    databaseURL: REACT_APP_FIREBASE_DATABASE_URL || '',
    projectId: REACT_APP_FIREBASE_PROJECT_ID || '',
    messagingSenderId: REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
    serverKey: REACT_APP_FIREBASE_SERVER_KEY || '',
  },
  clockIntervalMs: 5000,
  loadLogCountLimit: 2000,
  googleMaps: {
    apiKey:
      REACT_APP_GOOGLE_MAPS_API_KEY || STORYBOOK_GOOGLE_MAPS_API_KEY || '',
    zoom: 15,
  },
  encryptKey: REACT_APP_ENCRYPT_KEY || '',
  concrete: {},
  apiHost: REACT_APP_API_HOST || '',
  ...(isDev ? configDevelopment : configProduction),
}

export default config
